// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

export default () => (
    <svg
        width='41'
        height='41'
        viewBox='0 0 41 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
    >
        <circle
            cx='20.1992'
            cy='20.002'
            r='20'
            fill='url(#pattern-github)'
        />
        <defs>
            <pattern
                id='pattern-github'
                patternContentUnits='objectBoundingBox'
                width='1'
                height='1'
            >
                <use
                    xlinkHref='#image0_615_81864'
                    transform='scale(0.0208333)'
                />
            </pattern>
            <image
                id='image0_615_81864'
                width='48'
                height='48'
                xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFJUlEQVRoBc1ZTSh0XxifmntuI2KIEkKylWIhbJRCEq+ykI1ZKZIohZVJPhY2kpDS/42sxLwp+ayRkmQxiuSjTDZiJV+R8Lw95z9nuvfOPfdjzNzXqemee+ec8/x+z8c953muzRaZ5rTb7S5CyJgoih5CiF8QhHtCCEh+fkKIF8cQQpptNlt2ZESHv4pTFMX+ACgpUDN9378gQ4GraNgMcLWx/0XdKqjxKACXkUEZ4TsFf2Y2IQTNLRMWxXt/xKyBPhptrXMUcW+323/xdWrgH0EQMEit0rqqnLBd6ieAZ8ozTUIUxV9s8g+64t5hqGXzfF4QBMBftEjprH9vKLBxF1UDmJCQAPv7+3BwcACjo6NQUlISETIIurCwEPr7+2F3dxfOzs4gPz+fpySfpgm0/L66uhqk7evrC9bX16G4uJgKE0WRXpkWHQ4HZGRkQGZmJiQlJYHdbg8hnJaWBktLS/Dy8iJdGlpbW3kEQBRFN48Evuu5E/v6+mRC2M3n5yeMj49DV1cXLC4uwvn5OTw+PgI+Zw37CPL6+hpWV1fp2KGhIXh+fmZDZNeZmRkuDkIIupIzhAQh5LcWARRoVdva2gqxlhSbmhU0tY+TBwcHrcJPXVPnZSG3AiEEj8JaZoP29nbLCExNTWliQawyKxg555SVlQEGrhWtra0NAeqR8LI40HUfZLy2tmYFdirj5OQEUlNT9QgADWYj7uNyuSwDzwSNjIzoEsAs0CYIAqZ43MFoSnz9Wd2enp4gPj6eiyuAecymlRIieNxx/1XDF4eOcv8gAdWjA5vI28CsIDU7O6tJALEjAc1BExMTVmBVlbG5uam5odFdWY/A5OSk6uJWPNzZ2dEjAD/aAhsbG4YIKAtQQZfCIB4eHrZC2aoyFhYWDBHQDOKWlhbVxa14aGAv8OM+gKXAoNaV/dzcXMuOEEqlNDQ0cHEFcHp1NzI8Ffr9fuXaUb9/f3+HlJQUPQJjtkBRljsQ46CzszPqgJUC5ufnuZgkXkITfafkgeqk5ORkuLi4UMqI2v3DwwNkZWWpYpFidTgc/1e4tY4TOAHdqKamBnBhK1pHR4cueEwB2HEa48AtZcbr19XV0Xw3WiQwd0Z3RbflYZA8l9WJ0I1k+wGrLkgm0EVLS0tpyhdJEpgoHR8fQ2VlpRHgdEzQfZgZpFZA8Fgy2dvbA0zmMQakWsF+RUUFTE9Pw83NTdivWXRJrECge8bExBgGTwjBbwkhTWaF5ubmYNnj9PSUZkhITGmR2NhYKCgogPr6evD5fLqGuby8hMbGRigqKgKsHSnXM3Ifon1GRWmFvLw8uLq6oqC2t7cBwfIElJeXG7YE1pB46+g9lyXzDLj0qkzwq6qq4OPjg5LAAOMJWF5e1tU+G3B0dARxcXHctXgy6PlfClatj+ZRBvTKygqTDQMDA9RfMQ5YXOTk5MDt7W1wjF4HFYJHFA2gIf9hwZnrOkoiykQf/VXa7u7uADU+NzcHh4eHQQtJx+j1cU0zBLDkr8SpeS+NBxQU6cQGc22jBHT9nsdESaK7uztiG5lRAmGDZ6TwQ5s0JhITE6G2thZ6e3tpvbSnpweampoAT49mmh6BwEcWF8PxrWsgsLmJD34HeHt7M4Oflms0XMhnOGDNMFO6FAOQnp4Or6+v3yaAWkcZZjCZHhuwhuxbAlrgOwQYcKfTGfrhwjRCgxMCRFyCIPjCJSAIghc1bilwNX5utzsbALACPAYAXgBQ5qD3gWeewBiXx+OJiLb/Aqw2PCxKTcFTAAAAAElFTkSuQmCC'
            />
        </defs>
    </svg>
);
